import { render } from "./ServiceDetail.vue?vue&type=template&id=17f5d0ef&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"

import "./ServiceDetail.vue?vue&type=style&index=0&id=17f5d0ef&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f5d0ef"]])

export default __exports__